import { render, staticRenderFns } from "./FieldItem.vue?vue&type=template&id=523d039e&scoped=true"
import script from "./FieldItem.vue?vue&type=script&lang=js"
export * from "./FieldItem.vue?vue&type=script&lang=js"
import style0 from "./FieldItem.vue?vue&type=style&index=0&id=523d039e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523d039e",
  null
  
)

export default component.exports